export const pageSizeByAdmLevels = {
  "BD_adminLevel1": 20,
  "LK_adminLevel1": 1000,
  "LK_adminLevel2": 1500,
  "LK_adminLevel3": 1500,
};

export const pageSizeByADM = {
  "BD_ADM1": 70,
  "BD_ADM2": 50,
  "BD_ADM3": 150,
  "PH_ADM1": 1,
  "PH_ADM2": 5,
  "PH_ADM3": 65,
  "MY_ADM1": 10,
  "MY_ADM2": 60,
  "MY_ADM3": 100,
  "LK_ADM1": 5,
  "LK_ADM2": 20,
  "LK_ADM3": 150,
};

export const borderLvlToAdmLvl = {
  ADM1: "adminLevel1",
  ADM2: "adminLevel2",
  ADM3: "adminLevel3"
}

export const adminLevelToAdm = {
  adminLevel1: "adm1",
  adminLevel2: "adm2",
  adminLevel3: "adm3"
}


export const timeOutForApiCall = 600;